import { useState } from "react";
import { useUserStore } from "@/stores/userStore";
import { useTeamMemberSync } from "@/hooks/useTeamMemberSync";
import { Outlet } from "react-router";
import Header from "./Header";
import SideBar from "./SideBar";
import ImpersonationBar from "./ImpersonationBar";
import CopyrightFooter from "@/components/CopyrightFooter";

/**
 * Dashboard layout for authenticated users
 * Contains sidebar, header, and main content area
 */
const DashboardLayout = () => {
  const [showSidePanel, setShowSidePanel] = useState(window.innerWidth >= 1024);
  const isImpersonating = useUserStore((s) => Boolean(s.superAdminStore || s.adminStore));

  // useEffect(() => {
  // const handleResize = () => {
  //   if (window.innerWidth >= 1024) {
  //     setShowSidePanel(true);
  //   } else {
  //     setShowSidePanel(false);
  //   }
  // };
  // window.addEventListener("resize", handleResize);
  // return () => window.removeEventListener("resize", handleResize);
  // }, []);

  /**
   * Toggles the side panel visibility (only effective on mobile/tablet)
   * @param state - New visibility state for the side panel
   */
  function toggleSidePanel(state: boolean) {
    setShowSidePanel(state);
  }

  useTeamMemberSync();

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <SideBar toggleSidePanel={toggleSidePanel} showSidePanel={showSidePanel} />
      <div className="flex flex-1 flex-col h-screen overflow-hidden">
        {isImpersonating && <ImpersonationBar />}
        <Header showSidePanel={showSidePanel} toggleSidePanel={toggleSidePanel} />
        <main className="flex flex-1 flex-col overflow-y-auto">
          <div className="flex-1">
            <Outlet />
          </div>
          <CopyrightFooter className="border-t border-gray-100" />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
